import StampDutyCalculator from '../components/StampDutyCalculator';
import { defineCalculator } from './defineCalculator';

defineCalculator('scl-stamp-duty-calculator', StampDutyCalculator);
